module.exports = __webpack_public_path__ + "static/media/pstory.584f36c6.png";